import { render } from "./ReceiptUpload.vue?vue&type=template&id=ecc18eec&ts=true"
import script from "./ReceiptUpload.vue?vue&type=script&lang=ts"
export * from "./ReceiptUpload.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__